import axios from "axios";
import React, { useEffect, useState } from "react";
import InvoiceList from "../../components/invoice/InvoiceList";

const List = () => {
  const [tableState, setTableState] = useState(() => {
    return {
      page : 1,
      pageSize : 10,
      totalDocs : 0,
      docs: [],
      totalPage: 0,
    };
  });
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const getInvoiceList = () => {
    const user = localStorage.getItem("merchant-web");
    const parsedUser = JSON.parse(user);
    const payload = {
      merchantCode: parsedUser?.state?.user?.merchantCode,
      page: "1",
      limit: "10",
    };
    setLoading(true);
    axios
      .post("/api/v1.0/invoice/list", payload)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setInvoices(data?.result?.docs);
        }
        setTableState((prev) => ({
          ...prev, 
          page: data?.result?.page,
          docs: data?.result?.docs,
          totalDocs: data?.result?.totalDocs,
          totalPage: data?.result?.totalPages,
        }))
      })
      .catch((e) => {
        console.error("Fetch Invoice List: ", e);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getInvoiceList();
  }, []);
  return (
    <div
      style={{
        padding: 20,
        height: "100%",
      }}
    >
      <div className="invoice__header">
        <h1>Нэхэмжлэхүүд</h1>
      </div>
      <div>
        <InvoiceList invoices={invoices} tableState={tableState} loading={loading}/>
      </div>
    </div>
  );
};

export default List;
